<div class="xl:w-full flex align-items-center justify-content-center" style="height: 100vh;">

  <div class="surface-card p-4 shadow-2 border-round w-full lg:w-3">
    @if (this.failed) {
      <p-messages
        [(value)]="msgs"
        [enableService]="false"
        [closable]="false" />
    }
    <div class="flex flex-column">
      <label for="email1" class="block text-900 font-medium mb-2">Login</label>
      <input id="email1" type="text" placeholder="Login" pInputText class="w-full mb-3" [(ngModel)]="username">

      <label for="password1" class="block text-900 font-medium mb-2">Password</label>
      <input id="password1" type="password" placeholder="Password" pInputText class="w-full mb-3" [(ngModel)]="password">

      <button pButton pRipple label="Sign In" icon="pi pi-user" class="w-6 mx-auto" (click)="login()"></button>
    </div>
  </div>
</div>

